import React, { useState } from 'react';
import './HydroGear.css';
import logo from '../logos/hydrogear.png';

const HydroGear = () => {
    // Mock FAQ Data (Replace with actual FAQs later)
    const faqs = [
        { question: "What services do you offer?", answer: "We provide a wide range of services including custom consulting, support, and product solutions tailored to your business needs." },
        { question: "How can I contact support?", answer: "You can contact our support team via email at support@toptierbenefits.com" },
        { question: "What are your operating hours?", answer: "Our business operates Monday to Friday, from 8 AM to 6 PM CST." },
    ];

    // Expand/collapse FAQ answers
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="hydrogear-container">
            <h1 className="hydrogear-title">Hydro-Gear</h1>

            <img src={logo} alt="HydroGear Logo" className="hydrogear-logo" />

            {/* Link Box */}
            <a href="https://ca.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=3a41b0ae-a0c6-4c2a-a94d-c9ef5cc7b657&env=ca&acct=e6b74557-3473-4b9f-856e-4ebef6b2b3c7&v=2" target="_blank" rel="noopener noreferrer" className="hydrogear-box">
                <div className="hydrogear-content">
                    <h2>PATIENT ENROLLMENT FORM</h2>
                </div>
            </a>

            {/* FAQ Section */}
            <div className="hydrogear-faq-section">
                <h2 className="hydrogear-faq-title">Frequently Asked Questions</h2>
                <div className="hydrogear-faq-list">
                    {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className={`hydrogear-faq-item ${openIndex === index ? "active" : ""}`}
                        onClick={() => toggleFAQ(index)}
                    >
                        <div className="hydrogear-faq-question">
                        <strong>{faq.question}</strong>
                        <span className="hydrogear-faq-icon">{openIndex === index ? "-" : "+"}</span>
                        </div>
                        <div className={`hydrogear-faq-answer ${openIndex === index ? "show" : ""}`}>
                        {faq.answer}
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default HydroGear;